import { extendTheme } from "@chakra-ui/react"

const colors = {
  ink: {
    50: "#F5F2EC",
    100: "#E8E2D6",
    200: "#C9BFAD",
    300: "#8C8276",
    400: "#5C544A",
    500: "#3A332C",
    600: "#2A2620",
    700: "#1F1C17",
    800: "#1A1815",
    900: "#0F0E0C",
  },
  cream: {
    50: "#FBF7EE",
    100: "#F5EDE0",
    200: "#EDE2CB",
    300: "#DBC7A0",
  },
  amber: {
    50: "#FBEFD3",
    100: "#F5DCA0",
    200: "#EFC56A",
    300: "#E89C2D",
    400: "#C57E1B",
    500: "#94600F",
  },
  rule: "#2A2620",
}

const fonts = {
  heading: `'Fraunces', 'Times New Roman', serif`,
  body: `'DM Sans', system-ui, -apple-system, sans-serif`,
  mono: `'JetBrains Mono', ui-monospace, SFMono-Regular, monospace`,
}

const styles = {
  global: {
    "html, body": {
      bg: "ink.900",
      color: "cream.100",
      fontFamily: "body",
      fontFeatureSettings: `"ss01", "ss02", "cv11"`,
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
    },
    body: {
      backgroundImage: `url("data:image/svg+xml;utf8,<svg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0.95 0 0 0 0 0.93 0 0 0 0 0.87 0 0 0 0.04 0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>")`,
      backgroundRepeat: "repeat",
    },
    "::selection": {
      bg: "amber.300",
      color: "ink.900",
    },
    a: {
      _hover: { textDecoration: "none" },
    },
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: "heading",
      fontVariationSettings: `"opsz" 144, "SOFT" 50, "WONK" 0`,
      letterSpacing: "-0.02em",
    },
  },
}

const components = {
  Heading: {
    baseStyle: {
      fontFamily: "heading",
      fontWeight: 600,
      letterSpacing: "-0.025em",
    },
  },
  Button: {
    baseStyle: {
      borderRadius: "0",
      fontWeight: 500,
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      fontSize: "xs",
    },
    variants: {
      solid: {
        bg: "cream.100",
        color: "ink.900",
        _hover: { bg: "amber.200", _disabled: { bg: "cream.100" } },
        _active: { bg: "amber.300" },
      },
      outline: {
        border: "1px solid",
        borderColor: "cream.100",
        color: "cream.100",
        _hover: { bg: "cream.100", color: "ink.900" },
      },
      ghost: {
        color: "cream.100",
        _hover: { bg: "ink.700", color: "amber.200" },
      },
    },
    defaultProps: { variant: "outline" },
  },
}

const theme = extendTheme({
  config: { initialColorMode: "dark", useSystemColorMode: false },
  colors,
  fonts,
  styles,
  components,
})

export default theme
